export enum CategoryScreenFocusKeys {
  FacetButton = "CATEGORYSCREEN:FACETTYPEBUTTON",
  GlyphButton = "CATEGORYSCREEN:GLYPHBUTTON",
}
